module.exports = __webpack_public_path__ + "media/img/sda/standrew-student-banner-80b16f19fe5ade4bab6d43e8852b3981.png";